import React, { useState } from 'react';
import { Alert } from '@biome-design-system/ui/Alert';
import { AlertTitle } from '@biome-design-system/ui/AlertTitle';
import { useIntl } from '@kyruus/intl';
import type { AllPatientFields } from '@kyruus/crm-connector-widget';
import { messages as patientFieldMessages } from './messages';
import { messages } from '../useCrmConnector/messages';

export interface InvalidPatientDataAlertProps {
  title: string;
  invalidFields?: AllPatientFields[];
}

export const InvalidPatientDataAlert = ({
  title,
  invalidFields
}: InvalidPatientDataAlertProps) => {
  const intl = useIntl();
  const [showAlert, setShowAlert] = useState(true);
  if (!showAlert || !invalidFields?.length) {
    return null;
  }
  const handleClose = () => {
    setShowAlert(false);
  };
  return (
    <Alert
      severity="error"
      variant="filled"
      onClose={handleClose}
      closeText={intl.formatMessage(messages.closePatientDataAlert)}
      sx={(theme) => ({
        margin: `${theme.spacing(1)}`
      })}
    >
      <AlertTitle>{title}</AlertTitle>
      {invalidFields
        .map((field) => {
          const message = patientFieldMessages[field]
            ? intl.formatMessage(patientFieldMessages[field])
            : null;
          return message;
        })
        .filter((message) => Boolean(message))
        .join(', ')}
    </Alert>
  );
};
